(function () {
  function slugify(value) {
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initArticle(root) {
    var body = root.querySelector('[data-ll-article-body]');
    var toc = root.querySelector('[data-ll-article-toc]');
    var list = root.querySelector('[data-ll-article-toc-list]');
    if (!body || !toc || !list) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (headings.length < 2) return;

    var used = {};
    headings.forEach(function (heading, index) {
      var base = slugify(heading.textContent) || 'onderdeel-' + (index + 1);
      var id = base;
      var suffix = 2;
      while (used[id] || document.getElementById(id)) {
        id = base + '-' + suffix;
        suffix += 1;
      }
      used[id] = true;
      heading.id = id;

      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent;
      list.appendChild(link);
    });
    toc.hidden = false;
  }

  document.querySelectorAll('[data-ll-insight-article]').forEach(initArticle);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ll-insight-article]').forEach(initArticle);
  });
})();
